import { render, staticRenderFns } from "./WhatIsComprehensive.vue?vue&type=template&id=7ab214ea"
import script from "./WhatIsComprehensive.vue?vue&type=script&lang=js"
export * from "./WhatIsComprehensive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports